import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';
import { Map } from 'immutable';

import { MetadataItemEntity } from './metadata-item.entity';

export interface IMetadataListExtra
	extends IListColumnConfig<MetadataItemEntity> {
	isFixed?: boolean;
	isSelectable?: boolean;
	isSearchable?: boolean;
	isInGroup?: boolean;
	isVisible?: boolean;
	canBeHidden?: boolean;
	canBeReordered?: boolean;
	canBeChosen?: boolean;
	format?: string;
	visibleIndex?: number;
	visible?: boolean;
	hasHeaderFilter?: boolean;
}

interface IMetadataListEntity extends IListAttrs<MetadataItemEntity> {
	availableColumns: Map<string, IMetadataListExtra>;
}

const entityDefaults: IMetadataListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class MetadataListEntity
	implements
		IMetadataListEntity,
		IListOperations<MetadataListEntity, MetadataItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<IMetadataListExtra>
	): MetadataListEntity {
		const inst = new MetadataListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IMetadataListExtra]>());
		inst.availableColumns = Map(cols);
		return inst;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<MetadataItemEntity>
	> {
		return this.availableColumns;
	}

	public setElements(
		elems: Map<string, MetadataItemEntity>
	): MetadataListEntity {
		return produce(this, (draft: MetadataListEntity) => {
			draft.elements = elems;
		});
	}
}
